import { useEffect, useState } from "react";
import {
  getFileDownloadUrl,
  getFileFromFirebaseStorage,
} from "../../../api/firebase/firestoreService";
import { logDataToConsole } from "../../../utils/customLogger";

export const useFetchDocument = (pdfUrl: string | null) => {
  const [documents, setDocuments] = useState<File[]>([]);
  const [isFetchingDoc, setIsFetchingDoc] = useState<boolean>(false);
  const [errorInFetching, setErrorInFetching] = useState<boolean>(false);

  const fetchDownloadUrl = async (refUrl: string) => {
    setIsFetchingDoc(true);
    try {
      const downloadUrl = await getFileDownloadUrl(refUrl);
      const downloadedDocument = await getFileFromFirebaseStorage(downloadUrl);
      setDocuments([downloadedDocument]);
    } catch (err) {
      logDataToConsole("Error fetching document", err);
      setErrorInFetching(true);
      setDocuments([]);
    } finally {
      setIsFetchingDoc(false);
    }
  };

  useEffect(() => {
    if (pdfUrl) {
      fetchDownloadUrl(pdfUrl);
    }
  }, [pdfUrl]);

  return { documents, setDocuments, isFetchingDoc, errorInFetching };
};
